// src/Inicio.js
import React, { Component } from 'react';
import i18n from './I18N/I18n.js'; 
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import './css/inicio.css'; // Importar los estilos
import NavBar from './LogInNavBar.js';
import { apiSecuredRequest, apiPublicRequest, loadWeb3, cargarIdiomaPreferido} from './functions.js';
import { properties } from './properties.js';



class Inicio extends Component {
  async componentDidMount() {
    Cookies.remove('email');
    Cookies.remove('id');
    Cookies.remove('rol');
    Cookies.remove('direccion');
    Cookies.remove("direccion2")
    Cookies.remove("direccion3")
    await cargarIdiomaPreferido(this.cambiarIdioma);
  }

  cambiarIdioma = (idioma) => {
    i18n.changeLanguage(idioma); 
    this.forceUpdate(); 
    Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
  };
  



  render() {
    return (
      <>
      <NavBar cambiarIdioma={this.cambiarIdioma} />
      <section className="homePage_container">
     
  <h1 className="homePage_slogan">
    Certifica-T<br></br> 
  </h1>

  <div className="homePage_loginSection">
    <p className="homePage_loginTitle">{i18n.t('AccessToYourCertificates')}</p>
    <div className="homePage_buttonWrapper">
      <button
        className="homePage_metamaskBtn"
        onClick={ async  () => {
          const account = await loadWeb3();
          let data = JSON.stringify({
            "email": `${properties.appUser}`,
            "password": `${properties.appPass}`
        });
        let bearerVar = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/usuario/login`, data);
        
          let walletDir = JSON.stringify({
            "walletDir": `${account}`
          });

          const usuario = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/getUserByWalletDir`, walletDir, bearerVar.data.accessToken);
          Cookies.set("userId", usuario.data.id);
          if(usuario.data.termsAndConditions == "false"){
            Cookies.set("pendingSign", "true");
            Cookies.set("id", bearerVar.data.accessToken);
            window.location.href = `/terminosYcondiciones`;
          }else{
            Cookies.set("id", bearerVar.data.accessToken);
            window.location.href = `/listaEmpresas`;
          }
        }}
      >
        Metamask
      </button>

      <button
        className="homePage_emailBtn"
        onClick={() => {
          window.location.href = `/logIn`;
        }}
      >
        Log in
      </button>
    </div>
  </div>
</section>

      </>
    );
  }
}

export default withTranslation()(Inicio);

